import { render, staticRenderFns } from "./ListClaim.vue?vue&type=template&id=b65e1b24"
import script from "./ListClaim.vue?vue&type=script&lang=js"
export * from "./ListClaim.vue?vue&type=script&lang=js"
import style0 from "./ListClaim.vue?vue&type=style&index=0&id=b65e1b24&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports